import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import {
  Anticontainer,
  Badge,
  CircleImagesWrapper,
  Image,
  MainInfo,
  SupportBanner,
  TitleWrapper,
  Users,
  VideoWrapper,
} from './style';
import { CTA, CardCourses, CircleImage, HtmlRaw, Text } from '../../../atoms';
import Icon from '../../../atoms/Icon';
import CustomCarousel from '../../CustomCarousel';
import { Settings } from '../../CustomCarousel/settings';
import routes from '../../../../routes';
import { CarouselWrapper } from '../../CustomCarousel/style';
import { COURSE_RECOMMEND } from '../../../../app/redux/actions/coursedetails';
import { CircleImageColors } from '../../../theme/partials/colors';
import { SUPPORT_MAIL_GET } from '../../../../app/redux/actions';
import { getUrlWithToken } from '../../../../utils/common';
import { useHighlightText } from '../../../../utils/highlight';

const CourseOverview = ({
  data,
  recommendCourse,
  getSupportMail,
  supportMail,
}) => {
  const navigate = useNavigate();
  const [relatedCourses, setRelatedCourses] = useState([]);

  useEffect(() => {
    if (!supportMail) getSupportMail();
    if (data?.related_courses?.length > 0) {
      setRelatedCourses(data.related_courses);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getUsersLabel = ({
    users_recommended,
    users_recommended_floor_10,
    users_recommended_floor_100,
  } = {}) => {
    if (users_recommended_floor_100 > 0) {
      return `Più di ${users_recommended_floor_100}`;
    }
    if (users_recommended_floor_10 > 0) {
      return `Più di ${users_recommended_floor_10}`;
    }
    return `${users_recommended}`;
  };

  return (
    <>
      <TitleWrapper>
        <Text type="h2">Descrizione percorso formativo</Text>
        <CTA
          btnText="Inizia"
          type="primary"
          onClick={() =>
            navigate(`${routes.courseDetails.path}/${data?.id}/attività`)
          }
        />
      </TitleWrapper>
      <MainInfo>
        <div>
          <Text type="b3">
            <HtmlRaw html={useHighlightText(data?.description)} />
          </Text>
        </div>
        {data?.panoramic_media?.url &&
          (data?.panoramic_media?.type === 'video' ? (
            <VideoWrapper>
              <ReactPlayer
                url={getUrlWithToken(data.panoramic_media?.url)}
                controls
                width="auto"
                height="auto"
              />
            </VideoWrapper>
          ) : (
            <Image src={data.panoramic_media?.url} />
          ))}
      </MainInfo>
      {Object.keys(data?.recommended_info)?.length > 0 &&
        data?.typology === 'course' && (
          <>
            <Text type="h2" mb={44}>
              Utenti
            </Text>
            <Users>
              <div>
                <Badge>
                  <Icon type="award-02" size={26} clickable={false} />
                </Badge>
                <Text type="b3">
                  <b>{data?.users_completed || 0} utenti</b>&nbsp;hanno
                  completato il corso
                </Text>
              </div>
              <CircleImagesWrapper>
                {(data?.recommended_info?.users_recommended_initials || [])
                  .slice(0, 7)
                  .map((u, i) => (
                    <CircleImage
                      key={`user-${i}`}
                      name={{ first_name: u }}
                      size={52}
                      bgColor={CircleImageColors[i]}
                    />
                  ))}
                {data?.recommended_info?.users_recommended_floor_10 > 0 && (
                  <CircleImage
                    fullText={`+${data?.recommended_info?.users_recommended_floor_10}`}
                    size={52}
                    bgColor="#EBECED"
                    color="#0066CC"
                    className="more-circle"
                  />
                )}
              </CircleImagesWrapper>
              <Text type="b3">
                <b>{getUsersLabel(data?.recommended_info)} utenti</b>
                &nbsp;consigliano questo contenuto
              </Text>
              {data?.recommended_info && (
                <CTA
                  type="tertiary"
                  btnText="Consiglia"
                  icon="heart-rounded"
                  classes={`btn-recommend ${
                    data?.recommended_info?.recommended ? 'recommended' : ''
                  }`}
                  onClick={() => recommendCourse(data?.id)}
                />
              )}
            </Users>
          </>
        )}
      {supportMail && (
        <>
          <Text type="h2" mb={32}>
            Supporto
          </Text>
          <SupportBanner>
            <div className="wrapper">
              <Icon type="message-chat-circle" size={42} clickable={false} />
            </div>
            <Text type="h2">
              Hai bisogno di assistenza tecnica? Contatta l’Help desk
            </Text>
            <a href={`mailto:${supportMail}`} aria-label="Contatta">
              <CTA btnText="Contatta" />
            </a>
          </SupportBanner>
        </>
      )}
      {relatedCourses?.length > 0 && (
        <>
          <Text type="h1.5" mb={32}>
            Potrebbe interessarti anche
          </Text>
          <Anticontainer>
            <CarouselWrapper>
              <CustomCarousel config={Settings}>
                {(relatedCourses || []).map((item) => (
                  <CardCourses
                    item={item}
                    key={`news-${item?.id}`}
                    onClick={() =>
                      navigate(
                        `${routes.courseDetails.path}/${item.id}/panoramica`
                      )
                    }
                  />
                ))}
              </CustomCarousel>
            </CarouselWrapper>
          </Anticontainer>
        </>
      )}
    </>
  );
};

CourseOverview.propTypes = {
  // HOC: state
  data: PropTypes.object.isRequired,
  supportMail: PropTypes.string,
  // HOC: dispatch
  getSupportMail: PropTypes.func,
  recommendCourse: PropTypes.func,
};

export default connect(
  (state) => {
    const data = state.coursedetails;
    const { supportMail } = state.app;
    return {
      data,
      supportMail,
    };
  },
  (dispatch) => ({
    recommendCourse: (id) => dispatch({ type: COURSE_RECOMMEND._REQUEST, id }),
    getSupportMail: () => dispatch({ type: SUPPORT_MAIL_GET._REQUEST }),
  })
)(CourseOverview);
